<template>
  <div>
    <br/><br/><br/><br/>
    <div class="container">
      <div class="row">
        <div class="col-sm" align="center">
          <span style="font-size:30px">
            Access Denied
          </span>
          <br/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AccessDenied',
    data () {
      return {
        error: ''
      }
    },
    mounted () {
      // Access Denied
      this.error = 'Access Denied'
    }
  }
</script>
